var fvChannel = require('glRadio').channel('FV');


/*
* Store original for PRODUCTION to call if source not from script file (and to not override any existing
* */

var existingWindowOnError = window.onerror;

module.exports = {

    ajaxError: function( jqXHR, shortMessage ) {

        var dialogOptions = {
            type: 'error',
            shortMessage: shortMessage,   //eg: 404 Not Found: Cannot DELETE /document/FILECABINET/1188/2643334/notes/1
            detailedMsg: fvChannel.request( 'ajaxErrorMessage', jqXHR )
        };

        this.trigger( 'alert:show', dialogOptions );

    },

    /*
    * Note: if running in dev mode (webpack eval), url can be empty in Chrome and malformed in Firefox -- should work in PROD.
    * -- eg: ["http:", "", "localhost:8080", "docview", "public", "dv", "viewer.js line 1201 > eval"]
    * Note: new html spec, now in Chrome, FF: message, source, lineno, colno, error.
    * Detail is optional : link ajax errors to the alert view.
    * Note: now applied from viewer channel.
    * TODO: send ajax messages to log file / the back end ...
    * */
    onerror: function(msg, url, line) {

        var aUrl = url.split('/'),
            script = _.find(aUrl, function(i) {
                return i === FV._src;
            });

        /*
        * Don't handle uncaught errors not from the viewer.
        * Also: won't get picked up in webpack dev mode (script will be ''), so
        * */

        if (PRODUCTION && !script) {
            existingWindowOnError && existingWindowOnError();  // if not defined will be null
            return;
        }

        /*
        * TODO: ( ... still ... ? )
        * - diff method to handle errors if the first instance isn't yet created -- if not now will go to console.
        * - combo above in the function logic
        * */
        fvChannel.command('updatePostRunTimeError', msg, url, line);


        // If you return true, then error alerts (like in older versions of Internet Explorer) will be suppressed.
        var suppressErrorAlert = true;
        return suppressErrorAlert;
    }

};





/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/FV/error.js
 ** module id = 75
 ** module chunks = 0
 **/